import { reassessmentTriggerReasons } from 'constants/reassessmentTriggerReasons'

export const getCongregationNameByGroup = (groupId, options = []) => {
  const match = options.find((option) => option.value === groupId)
  return match ? match.label : 'newCongregationTitle'
}

export const getRejectReasonNames = (triggerReasonIds = []) => {
  return triggerReasonIds
    .map((element) => reassessmentTriggerReasons.find((item) => item.id === Number(element))?.name)
    .filter(Boolean)
}

export const hasQualifyingReason = (reasons = []) => {
  if (!Array.isArray(reasons) || reasons.length === 0) return true
  return reasons.some((element) => Number(element) === 1)
}
